import { useLazyQuery } from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { FileStatus, ImageProps } from '../../components/UploadBox/ImageBox'
import { UploadBox } from '../../components/UploadBox/index'
import { CHANNEL_LOGO_QUERY } from '../../graphql/upload'
import { getRoleFromStorage } from '../../helpers/userData'
import channelPagesRoleManagement from '../../staticRoleManagement/channelPagesRoleManagement'
import { Image } from '../../types/image'

export const UploadBoxForChannel = () => {
  const [images, setImages] = useState<ImageProps[]>([])
  const params = useParams<{
    channelCode: string
    id: string
    page: string
  }>()

  const [getImages, { data, loading }] = useLazyQuery<{
    channelLogo: Image
  }>(CHANNEL_LOGO_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    getImages({
      variables: {
        channelCode: params.channelCode
      }
    })
  }, [])

  useEffect(() => {
    if (data) {
      let newImages: ImageProps[] = []

      newImages = [
        {
          fileURL: data.channelLogo.url,
          status: FileStatus.COMPLETED,
          fileName: data.channelLogo.name,
          fileSize: data.channelLogo.size,
          mediaID: data.channelLogo.id
        }
      ]

      setImages(newImages)
    }
  }, [loading, data])

  const hasAccessToModifyChannellogo = channelPagesRoleManagement
    .find((item) => item.route === '/channels/:id/:channelCode/:page')
    ?.tabs?.find((routeTabItem) => routeTabItem.params.page === 'logo')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <>
      <UploadBox
        hasAccess={hasAccessToModifyChannellogo}
        loading={loading}
        entityCode={params.channelCode}
        entityid={params.id}
        entityType={'Channel'}
        images={images}
        setImages={setImages}
        imageType={'Logo'}
      />
    </>
  )
}
